import React from 'react';
import ErrorPageStyled from './ErrorPage.styled';
import { LinkButton } from 'dbi-pearl-ui-kit';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_ROUTES } from 'shared/constants/navigation';

const ErrorPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <ErrorPageStyled>
            <section className={'back'}>
                <LinkButton
                    data-testid="backButton"
                    startIcon="arrow-left"
                    variant={'accent'}
                    className={'back-button'}
                    onClick={() => navigate(APP_ROUTES.vendor.dashboard)}
                >
                    {t('EditBack')}
                </LinkButton>
                <h1>{t('Error.title')}</h1>
                <h2>{t('Error.subtitle')}</h2>
            </section>
            <section className={'code'}>
                <p>{t('Error.code')}</p>
            </section>
        </ErrorPageStyled>
    );
};

export default ErrorPage;
